import {
  useCssVars
} from "./useCssVars.js";
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  useCssVars
};
//# sourceMappingURL=index.js.map
